import React from 'react';

class InputBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			initialValue: props.value
		};
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this._input.classList.add('invalid-field');
		else
			this._input.classList.remove('invalid-field');
	}

	validate = () => {
		if (this.props.onValidate)
			return this.props.onValidate(this.state.value);

		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt(this);
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_filter = (e) => {
		if (this.props.filter) {
			if (!this.props.filter(e.key))
				e.preventDefault();
		}
	}

	_update = (value) => {
		const me = this;

		this.setState({ value }, function () {
			const validationResult = this.validate();
			const requiredPassed = this.completed();
			const validationPassed = (validationResult === null || validationResult === undefined);
			const status = requiredPassed && validationPassed;

			// Show error status if neccesary
			this.flag(status);

			// Prepare the value that we'll be submitting to the form
			if (this.props.valueBuilder)
				value = this.props.valueBuilder(value);

			// Dirt?
			if (this.state.initialValue !== value) {
				this.onDirt();
			}

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
			else
				// If not, only trigger this comp change
				this.onChange(value);
		});
	}

	_handleInputChange = (e) => {
		this._update(e.target.value);
	}

	_handleInputKeyPress = (e) => {
		this._filter(e);

		if (e.key === "Enter")
			this.props.onEnter && this.props.onEnter(e.target.value);
	}

	_handlePaste = (e) => {
		// Get pasted data via clipboard API
		let clipboardData = e.clipboardData || window.clipboardData;
		let pastedData = clipboardData.getData('Text');

		this.props.filter && !this.props.filter(pastedData) && e.preventDefault();
	}

	_handleInputFocus = (e) => {
		this.props.onFocus && this.props.onFocus();
	}

	_handleInputBlur = (e) => {
		this._update(e.target.value);
		this.props.onBlur && this.props.onBlur();
	}

	// React lifecycle events
	componentDidMount() {
		if (this.props.autoFocus)
			this.focus();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			let value = "";

			if (nextProps.value !== null && nextProps.value !== undefined)
				value = nextProps.value.toString();

			// Re-evaluate required and validations
			const validationResult = this.validate();
			const requiredPassed = !((value === "" || value === null) && nextProps.required);
			const validationPassed = (validationResult === null || validationResult === undefined);
			const status = requiredPassed && validationPassed;

			// Show error status if neccesary
			this.flag(status);

			this.setState({
				value: value
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled
			|| nextState.value !== this.state.value);
	}

	render() {
		// 'this.state.value || ""' would cause 0 to be ignored.
		const value = this.state.value;

		let opts = {
			id: this.props.id,
			onMouseOver: this.props.onMouseOver,
			onMouseOut: this.props.onMouseOut,
			name: this.props.name,
			value: (value !== undefined && value !== null) ? value : "",
			type: this.props.type || "text",
			maxLength: this.props.maxLength,
			placeholder: this.props.placeholder,
			style: this.props.style,
			autoComplete: "off",
			className: "form-control " + this._className(),
			disabled: this.props.disabled ? "disabled" : undefined,
			readOnly: this.props.readonly ? "readonly" : undefined,
			onChange: this._handleInputChange,
			onKeyDown: this._handleInputKeyDown,
			onKeyPress: this._handleInputKeyPress,
			onBlur: this._handleInputBlur,
			onFocus: this._handleInputFocus,
			onPaste: this._handlePaste
		};

		return (<input {...opts} ref={(input) => this._input = input} />)
	}
}

export default InputBox;

// This is not a form control
InputBox.defaultProps = {
	formControl: false,
	managed: false,
	maxLength: 30
};



// WEBPACK FOOTER //
// ./src/fw/forms/components/InputBox.js